@if(isAdmin) {
<div class="header">
  <p-menu #widgetMenu [model]=dashboardService.widgetsToAdd() [popup]="true" />
  <p-button label="Widget einfügen" icon="pi pi-plus-circle" styleClass="function-btn" [rounded]="true" (onClick)="widgetMenu.toggle($event)" />
  <p-button label="Dashboard aktualisieren" icon="pi pi-save" styleClass="function-btn" [rounded]="true" (onClick)="updateDashboard()" />
</div>
}
<div #dashboard class="dashboard-widgets">
  @for (widget of dashboardService.addedWidgets(); track widget.widgetId) {
  <app-widget [snapX]="colWidth + gridGap" [snapY]="rowHeight" [ngClass]="{'p-panel p-component': true}"
    [style.gridColumn]="widget.columnPosition + ' / span ' + widget.columnSpan"
    [style.gridRow]="widget.rowPosition + ' / span ' + widget.rowSpan" cdkDrag [cdkDragDisabled]="false"
    (cdkDragStarted)="onDragStarted()" (cdkDragMoved)="onDragMoved($event, widget)"
    (cdkDragEnded)="onDragEnded($event, widget)" (resizeEnd)="onResizeEnd($event, widget)" appGridSpan
    [isEditable]="true" [data]="widget" ></app-widget>
  }
  <!-- absolutes Overlay -->
  <div *ngIf="dragPreview.visible"
    class="drop-placeholder absolute border-2 border-dashed border-blue-500 pointer-events-none transition-all"
    [style.left.px]="((dragPreview.columnPosition ?? 0)-1) * colWidth + gridGap"
    [style.width.px]="(dragPreview.columnSpan ?? 1)* colWidth + gridGap"
    [style.height.px]="(dragPreview.rowSpan ?? 1) * rowHeight + gridGap"
    [style.top.px]="((dragPreview.rowPosition ?? 0)-1) * rowHeight + gridGap">
  </div>
</div>
<!-- pDroppable (onDrop)="drop(widget)" -->